module.exports = __webpack_public_path__ + "img/53.fb4c1dd1.jpg";